<template>
  <div class="student">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <div class="reputation-wrap">
            <jm-crumbs :crm_id="this.$route.params.id"/>
            <el-form :model="formData">
              <el-form-item>
                <span class="form-tit">口碑标题：</span>
                <el-input
                  type="text"
                  placeholder="请输入标题最多15个字"
                  v-model="formData.r_title"/>
              </el-form-item>
              <el-form-item>
                <span class="form-tit">口碑内容：</span>
                <quill-editor
                  v-model="formData.r_content"
                  :options="editorOption"/>
              </el-form-item>
              <el-form-item>
                <span class="form-tit">Offer选择：</span>
                <el-radio-group v-model="formData.offer_school_id">
                  <el-radio
                    v-for="item in formData.offer_school"
                    :label="item.id"
                    :key="item.id">
                    学校：<span>{{ item.schoolname }}</span> - 专业：<span>{{ item.zhuanye_name }}</span> - 学位类型：<span>{{ item.xuewei_type }}</span> - 申请结果：<span>{{ item.shenqing_result > 1 ? '失败' : '成功' }}</span>
                  </el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item>
                <div class="el-col-12">
                  <span class="form-tit jm-cb">口碑图片：</span>
                  <jm-upload
                    class="upload-img"
                    action="/newfib.php/index/Offer_small/upload"
                    :on-success="handleFile"
                    :show-file-list="false"
                    :data="{crm_id: this.$route.params.id, rid:formData.offer_id, file_key:'offer_review'}"
                  >
                    <el-button
                      @click="typeChange"
                      type="primary">上传图片</el-button>
                  </jm-upload>
                  <div class="crop-endimg-area">
                    <img
                      v-if="imgHidden"
                      id="cropImg1"
                      :src="formData.img_url"
                      alt="">
                    <canvas
                      v-show="!imgHidden"
                      id="endImg"
                      width="245"
                      height="300"/>
                  </div>
                </div>
                <div class="el-col-12">
                  <span class="form-tit jm-cb">头像图片：</span>
                  <jm-upload
                    class="upload-img"
                    action="/newfib.php/index/Offer_small/upload"
                    :on-success="handleFile"
                    :show-file-list="false"
                    :data="{crm_id: this.$route.params.id, rid:formData.offer_id, file_key:'offer_head_review'}"
                  >
                    <el-button
                      @click="typeChange"
                      type="primary">上传头像</el-button>
                  </jm-upload>
                  <div class="crop-endimg-area">
                    <img
                      class="crop-tximg"
                      :src="formData.head_url"
                      alt="">
                  </div>
                </div>
              </el-form-item>
              <el-form-item>
                <el-radio
                  v-model="formData.review_status"
                  :label="2">启用</el-radio>
                <el-radio
                  v-model="formData.review_status"
                  :label="1">禁用</el-radio>
              </el-form-item>
              <el-form-item>
                <span class="form-tit">排序：</span>
                <el-input
                  class="jm-input135"
                  type="number"
                  v-model="formData.r_order"
                  placeholder="数字越大显示越靠前"/>
                <span class="form-tips">（数字越大显示越靠前）</span>
              </el-form-item>
              <el-form-item>
                <el-button
                  :class="submitLock ? '' : 'submit-disabled'"
                  @click="saveForm"
                  type="primary">保存</el-button>
              </el-form-item>
              <el-form-item>
                <div
                  v-if="cropLock"
                  class="reputation-crop-area-bg">
                  <div class="reputation-crop-area">
                    <vueCropper
                      ref="cropper"
                      output-type="png"
                      :img="imgSrc"
                      :auto-crop="imgCropperData.autoCrop"
                      :auto-crop-width="imgCropperData.autoCropWidth"
                      :auto-crop-height="imgCropperData.autoCropHeight"
                      :fixed-box="imgCropperData.fixedBox"
                    />
                    <div class="btn-area">
                      <el-button
                        @click="cropClose"
                        type="info">取消</el-button>
                      <el-button
                        @click="cropSure"
                        type="primary">确定剪裁</el-button>
                    </div>
                  </div>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';
import VueCropper from 'vue-cropper';
import markImg from '@/assets/images/icon-mark.png';

export default {
  data() {
    return {
      formData: {
        id: 0,
        offer_id: null,
        crm_id: null,
        r_title: null,
        r_content: null,
        img_url: null,
        head_url: null,
        add_time: 0,
        r_order: 0,
        edit_time: 0,
        review_status: 1,
        offer_school_id: 0
      },
      editorOption: {
        placeholder: '请输入内容',
        modules: {
          toolbar: [
            ['bold', 'underline', 'strike'],
            [{ color: [] }, { background: [] }],
            ['clean'],
            ['image']
          ]
        }
      },
      imgCropperData: {
        accept: 'image/gif, image/jpeg, image/png, image/bmp',
        maxSize: 5242880,
        file: null, // 上传的文件
        imgSrc: '', // 读取的img文件base64数据流
        imgOsrc: '',
        autoCropWidth: 245,
        autoCropHeight: 300,
        autoCrop: true,
        fixedBox: true,
        markSrc: markImg,
      },
      cropLock: false,
      cropType: 1, // 1为口碑图，2为头像图
      imgHidden: true,
      submitLock: true
    };
  },
  components: {
    quillEditor,
    VueCropper
  },
  methods: {
    /**
       * 上传图片类型
       *
       * 孙倡东 <sunchangdong@tuozhongedu.com>
       */
    typeChange(e) {
      if (e.target.textContent === '上传图片') {
        this.cropType = 1;
        this.imgCropperData.autoCropHeight = 300;
      } else if (e.target.textContent === '上传头像') {
        this.cropType = 2;
        this.imgCropperData.autoCropHeight = 245;
      }
    },
    /**
       * 上传组件改变
       *
       * 孙倡东 <sunchangdong@tuozhongedu.com>
       */
    handleFile(response, file) {
      let _this = this;
      // 通过DOM取文件数据
      _this.file = file.raw;
      // 判断文件格式
      if (_this.imgCropperData.accept.indexOf(_this.file.type) === -1) {
        this.$alert('文件格式错误，请重新选择', '', {
          confirmButtonText: '确定',
        });
        return;
      }
      // 判断文件大小限制
      if (_this.file.size > 5242880) {
        this.$alert('文件大小不可超过5MB，请重新选择', '', {
          confirmButtonText: '确定',
        });
        return;
      }
      let reader = new FileReader();
      // 将图片将转成 base64 格式
      reader.readAsDataURL(_this.file);
      reader.onload = function () {
        _this.imgSrc = this.result;
        _this.cropLock = true;
        _this.imgCropperData.imgOsrc = response.data.fileurl;
      };
    },
    /**
       * 裁图插件关闭
       *
       * 孙倡东 <sunchangdong@tuozhongedu.com>
       */
    cropClose() {
      this.cropLock = false;
    },
    /**
       * 裁图插件确定
       *
       * 孙倡东 <sunchangdong@tuozhongedu.com>
       */
    cropSure() {
      this.$refs.cropper.getCropData((data) => {
        this.cropLock = false;
        if (this.cropType === 1) {
          let img = new Image();
          let mark = new Image();
          img.src = data;
          let canvas = document.getElementById('endImg');
          let ctx = canvas.getContext('2d');
          ctx.fillStyle = '#e8e9ee';
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          img.onload = () => {
            // 绘制图片
            ctx.drawImage(img, 0, 0);
            mark.src = this.imgCropperData.markSrc;
            mark.onload = () => {
              // 绘制水印
              ctx.drawImage(mark, 0, 0);
              let dataURL = canvas.toDataURL('image/png');
              this.$http._post({
                url: '/index/Offer_small/saveFile',
                data: { file_url: this.imgCropperData.imgOsrc, file_data: dataURL }
              }).then(() => {
                this.formData.img_url = this.imgCropperData.imgOsrc;
              });
            };
          };
          this.imgHidden = false;
        } else if (this.cropType === 2) {
          this.$http._post({
            url: '/index/Offer_small/saveFile',
            data: { file_url: this.imgCropperData.imgOsrc, file_data: data }
          }).then(() => {
            this.formData.head_url = this.imgCropperData.imgOsrc;
          });
        }
      });
    },
    /**
       * 保存
       *
       * 孙倡东 <sunchangdong@tuozhongedu.com>
       */
    saveForm() {
      this.submitLock = false;
      this.$http._post({
        url: '/index/Offer_small/saveReview',
        data: this.formData
      }).then(() => {
        this.$message.success('保存成功');
        window.location.reload();
      });
    }
  },
  /**
     * 页面加载
     *
     * 孙倡东 <sunchangdong@tuozhongedu.com>
     */
  mounted() {
    this.$http
      ._get({
        url: `/index/Offer_small/showReview?crm_id=${this.$route.params.id}`
      })
      .then((data) => {
        this.formData = Object.assign(this.formData, data.data);
        if (this.formData.review_status === 0) {
          this.formData.review_status = 1;
        }
        if (!this.formData.offer_school_id || this.formData.offer_school_id === 0) {
          if (this.formData.offer_school.length > 0) {
            this.formData.offer_school.forEach((item) => {
              if (item.shenqing_result === 1) {
                this.formData.offer_school_id = item.id;
              }
            });
          }
        }
      }).catch((data) => {
        if (data.data.result < 0 || data.data.offer_id === 0) {
          setTimeout(() => {
            this.$router.push({ name: 'editStudent', params: { id: this.$route.params.id } });
          }, 2000);
        }
      });
  }
};
</script>
<style>
  .quill-editor .ql-container {
    height: 200px !important;
  }
</style>
<style scoped>
  .reputation-crop-area{
    width: 800px;
    height:500px;
    position: fixed;
    left:50%;
    top:50%;
    margin-left: -400px;
    margin-top: -250px;
  }
  .reputation-crop-area-bg{
    position: fixed;
    width: 100%;
    height:100%;
    left:0;
    top:0;
    z-index: 11;
    background: rgba(0,0,0,.4);
  }
  .reputation-crop-area .btn-area{
    text-align: right;
    background: #fff;
    padding:10px;
  }
  #myCropper-input{
    position: absolute;
    left:0;
    top:0;
    width: 100%;
    height:100%;
    opacity:0;
    cursor: pointer;
  }
  .crop-endimg-area{
    display: block;
    margin: 10px auto;
  }
  .form-tips{
    color: red;
  }
  .reputation-wrap .el-radio{
    display: block;
    margin-left: 15px;
    margin-bottom: 8px;
  }
  .crop-tximg{
    background: #e8e9ee;
    -webkit-border-radius: 100%; -moz-border-radius: 100%; border-radius: 100%;
  }
  #endImg{
    position: relative;
    background: #e8e9ee;
  }
  .submit-disabled{
    pointer-events: none;
    background: #999;
  }
</style>
